/* eslint-disable */
import React, { useState, useEffect, useContext } from "react";
import DataTableFilter from "../Common/DataTableFilter";
import { useNavigate } from "react-router-dom";
import { ADD_HELP_DESK_FAQ, EDIT_HELP_DESK_FAQ } from "../Shared/constant";
import { WebSocketContext } from "../../App";
import { ClearFormSetFutios } from "../../redux/actions/adminActions";
import wsSend_request from "../../Api/ws/ws_request";
import { useSelector, useDispatch } from "react-redux";
import CommonTable from "../Common/CommonTable";

const HelpDeskFAQ = (props) => {
    const Navigate = useNavigate();
    const Dispatch = useDispatch();
    const { HelpDeskFAQList, device_id, selfInfo } = useSelector((state) => state.adminReducers);
    const [ userSearch, setUserSearch ] = useState("");
    const [ userType, setUserType ] = useState("all");
    const [ userLimit, setUserLimit ] = useState(10);
    const [ currentPage, setCurrentPage ] = useState(1);
    const { websocket } = useContext(WebSocketContext);
    const PermissionsAccess = selfInfo?.user?.permissions_access;

    // page change
    const currentFunction = (page) => {
        setCurrentPage(page);
    };
    
    // select user type
    const SelectUserTypeFnct = (e) => {
        setUserType(e.target.value);
        setCurrentPage(1);
    };

    useEffect(() => {
        if(selfInfo?.user?.user_type === 'super_admin' || (PermissionsAccess?.DealerApp[5]?.Edit || PermissionsAccess?.DealerApp[5]?.View)) {
            let param = { 
                "transmit": "broadcast", 
                "url": "help_desk_subcategory_list",
                "request" : { 
                    "status" : true, 
                    "limit" : 5000,
                    "page_no" : 1, 
                    "search" : "",
                    "order_by": "-updated_at"
                },
                "DeviceId" : device_id
            };
            wsSend_request(websocket, param);
        };
    }, [ websocket ]);

    // api calling
    const APICall = () => {
        if(selfInfo?.user?.user_type === 'super_admin' || (PermissionsAccess?.DealerApp[5]?.Edit || PermissionsAccess?.DealerApp[5]?.View)) {
            let param = { 
                "transmit": "broadcast", 
                "url": "help_desk_faq_list",
                "request" : { 
                    "status" : userType === "active" ? true : userType === "inactive" ? false : "", 
                    "limit" : userLimit,
                    "page_no" : currentPage, 
                    "search" : userSearch.trim(),
                    "sub_category_id": "",
                    "order_by": "-updated_at"
                },
                "DeviceId" : device_id
            };
            wsSend_request(websocket, param);
        };
    };

    // when page load api calling
    useEffect(() => {
        APICall();
    }, [ websocket, userSearch, userType, currentPage, userLimit ]);

    // create applications
    const cmnFnct = () => {
        Navigate(ADD_HELP_DESK_FAQ);
    };

    useEffect(() => {
        Dispatch(ClearFormSetFutios({
            url:"",
            action:false
        }));
    }, []);

    // TABLE COLUMNS ARRAY
    const TableColumns = [
        { key: 'question', label: 'Question', type: "label", sort: "" },
        { key: 'sub_category_id', label: 'Sub Category Name', type: "label_get_from_list", filterFrom: { list: "sub_category", label: "sub_category_name" }, sort: "", isCollapsable: false },
        { key: 'created_at', label: 'Created At', type: "date", sort: "" },
    ];

    return(<section className="Main_section">
        <DataTableFilter 
            filterType={""}
            searchType={"Question"}
            userSearch={userSearch}
            setUserSearch={setUserSearch}
            userType={userType} 
            setUserType={setUserType}
            userLimit={userLimit} 
            setUserLimit={setUserLimit}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            SelectUserTypeFnct={SelectUserTypeFnct}
            buttonvisible={(selfInfo?.user?.user_type === 'super_admin' || PermissionsAccess?.DealerApp[5]?.Edit) ? true : false}
            ButtonSet={{
                buttontitle: "Create Desk FAQ",
                function: cmnFnct
            }}
            searchdisable={true}
            ActiveInactiveFilter={true}
        />
        {/* COMMON TABLE */}
        <CommonTable 
            isTableAllow={true}
            style={{
                height: parseInt(HelpDeskFAQList?.pagination?.total_records) === HelpDeskFAQList?.list?.length ? "calc(100vh - 141px)" : parseInt(HelpDeskFAQList?.pagination?.total_records) > 10 ? "calc(100vh - 175px)" : "calc(100vh - 141px)"
            }}
            srNumber={{
                clickable: false,
                events: ""
            }}
            isCollapsable={false}
            tabName={"user-list"} // TAB URL
            PaginationCurrentPage={currentPage} // TAB CURRENT PAGE
            PaginationFunction={currentFunction} // PAGINATION CHNAGE FUNCTION
            TableColumns={TableColumns} // TABLE COLLUMNS & ROWS
            OrderList={HelpDeskFAQList} // CATEGORY LIST
            Pagination={HelpDeskFAQList?.pagination} // CURRENT TAB PAGINATION
            EditAccess={true} // EDITABLE ACCESS STATE
            isActionColumnAvailable={{
                isShow: true,
                label: "edit_help_desk_faq",
                naviagte: `${EDIT_HELP_DESK_FAQ}/`
            }}
            isActionTwoColumnAvailable={{
                isShow: false,
                url: "",
            }}
            isOdiFilterRowColorsAllow={false}
        />
    </section>)
}

export default HelpDeskFAQ;